import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spin, Empty, Button } from 'antd';
import useFetch from 'utils/fetch/useFetch';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { DEVICES, WAREHOUSES, FIRMWARE, BOXES, USERS } from 'api';
import { useSelector } from 'react-redux';
import Filter from './components/Filter';
import Select from './components/Select';
import Search from './components/Seacrh';
import List from './components/List';

function Devices({}) {
  const [stateFilter, setStateFilter] = useState(null);
  const [stateSelect, setStateSelect] = useState(null);
  const [pushItems, setPushItems] = useState(null);
  const [generalTotal, setGeneralTotal] = useState(null);
  const [stateSearch, setStateSearch] = useState(false);
  const total = useSelector((state) => get(state, `fetch.devices.total`, null));
  const limit = useSelector((state) => get(state, `fetch.devices.limit`, null));
  const { t } = useTranslation();
  const { data: storages, getData: getStorages } = useFetch(WAREHOUSES, {
    uniqId: 'warehouses',
    autoFetch: true,
  });

  const { data: firmware } = useFetch(FIRMWARE, {
    uniqId: 'firmware',
    autoFetch: true,
  });

  const { data, getData, loading, loadMore, updateData } = useFetch(DEVICES, {
    uniqId: 'devices',
    autoFetch: true,
    initialOptions: { limit: 30 },
  });

  const {
    data: users,
    updateData: updateUsers,
    getData: getUsers,
    deleteData: deleteUsers,
  } = useFetch(USERS, {
    uniqId: 'users',
    autoFetch: true,
  });

  const {
    data: boxes,
    getData: getBoxes,
    loading: loadingBox,
    updateData: updateBox,
    postData: postBox,
  } = useFetch(BOXES, {
    uniqId: 'boxes',
    autoFetch: true,
  });

  const loadMoreItems = () => {
    if (stateSearch || stateSelect || stateFilter) {
      getData({
        serial: stateSearch ? stateSearch : null,
        limit: pushItems,
        warehouse_id:
          stateSelect !== null && stateSelect !== '' ? stateSelect : null,
        outdated: stateFilter ? (stateFilter.oldVersion ? 1 : null) : null,
        synchronized: stateFilter ? (stateFilter.errorSync ? 0 : null) : null,
        box_id__is_null: stateFilter
          ? [stateFilter.notAtt ? 1 : null, stateFilter.att ? 0 : null]
          : null,
        online: stateFilter
          ? [stateFilter.online ? 1 : null, stateFilter.offline ? 0 : null]
          : null,
      });
      setPushItems(pushItems + 5);
    } else {
      loadMore(pushItems);
      setPushItems(pushItems + 5);
    }
  };

  useEffect(() => {
    if (data && !pushItems) setPushItems(data.length + 5);
  }, [data]);

  useEffect(() => {
    if (total && !generalTotal) {
      setGeneralTotal(total);
    }
  }, [total]);
  

  return (
    <Spin spinning={loading}>
      <Row gutter={[16, 16]}>
        <Col span={9}>
          <Filter
            limit={limit}
            select={stateSelect}
            setFilter={setStateFilter}
            getData={getData}
            stateSearch={stateSearch}
          />
        </Col>
        <Col span={6}>
          <Select
            limit={limit}
            setSelect={setStateSelect}
            filter={stateFilter}
            getDevices={getData}
            data={storages}
            stateSearch={stateSearch}
          />
        </Col>
        <Col span={9}>
          <Search
            filter={stateFilter}
            select={stateSelect}
            setStateSearch={setStateSearch}
            limit={limit}
            total={total}
            generalTotal={generalTotal}
            search={getData}
          />
        </Col>
      </Row>
      {data ? (
        <List
          data={data}
          firmware={firmware}
          boxes={boxes}
          getBoxes={getBoxes}
          users={users}
          updateBox={updateBox}
          updateDeviceFetch={updateData}
          getData={getData}
          limit={limit}
          updateUsers={updateUsers}
          getUsers={getUsers}        />
      ) : (
        <div className="flex flex-col items-center justify-center">
          <Empty />
        </div>
      )}
      {/* {data ? (
        total !== data.length ? (
          <div className="flex w-full mt-20 mb-20 justify-center items-center">
            <Button
              type="primary"
              onClick={() => {
                loadMoreItems();
              }}
            >
              {t('loadMore')}
            </Button>
          </div>
        ) : null
      ) : null} */}
    </Spin>
  );
}

Devices.propTypes = {};

export default Devices;
